(function() {
  function initScrollbar(section) {
    const grid = section.querySelector('.hc-grid');
    const thumb = section.querySelector('.hc-scrollbar__thumb');
    const track = section.querySelector('.hc-scrollbar__track');
    const scrollbar = section.querySelector('.hc-scrollbar');
    
    if (!grid || !thumb || !scrollbar || !track) return;
    
    function updateScrollbar() {
      if (window.innerWidth >= 1280) {
        scrollbar.style.display = 'none';
        return;
      }
      
      scrollbar.style.display = 'block';
      
      const scrollWidth = grid.scrollWidth - grid.clientWidth;
      const scrollLeft = grid.scrollLeft;
      
      if (scrollWidth <= 0) {
        thumb.style.width = '100%';
        thumb.style.left = '0';
        return;
      }
      
      const scrollPercentage = Math.min(scrollLeft / scrollWidth, 1);
      const visibleRatio = grid.clientWidth / grid.scrollWidth;
      const thumbWidth = Math.max(visibleRatio * 100, 10);
      const trackWidth = track.offsetWidth;
      const thumbPixelWidth = (thumbWidth / 100) * trackWidth;
      const maxThumbPosition = trackWidth - thumbPixelWidth;
      const thumbPosition = scrollPercentage * maxThumbPosition;
      
      thumb.style.width = thumbWidth + '%';
      thumb.style.left = thumbPosition + 'px';
      thumb.style.transform = 'none';
    }
    
    grid.addEventListener('scroll', updateScrollbar, { passive: true });
    window.addEventListener('resize', updateScrollbar);
    
    setTimeout(updateScrollbar, 100);
    requestAnimationFrame(updateScrollbar);
  }
  
  function initAllSections() {
    document.querySelectorAll('[id^="hc-section-"]').forEach(initScrollbar);
  }
  
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAllSections);
  } else {
    initAllSections();
  }
  
  if (typeof Shopify !== 'undefined' && Shopify.designMode) {
    document.addEventListener('shopify:section:load', (e) => {
      const section = e.target.querySelector('[id^="hc-section-"]');
      if (section) setTimeout(() => initScrollbar(section), 100);
    });
  }
})();
